/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import './device_profile_type';
import '../settings/spos/spos_settings';
import '../settings/rtl/rtl_settings';
import '../settings/kds/kds_settings';
import '../settings/rst/rst_settings';
import '../settings/terminal/terminal_api_settings';
import '../settings/device/square_hardware_settings';
import '../settings/apos/apos_settings';
import '../settings/rst/rst_mobile_settings';
import '../settings/kds/kds_expo_settings';
import '../settings/releasemanager/release_manager_settings';
import '../settings/fnbkiosk/fnb_kiosk_settings';
import '../settings/ipos/ipos_settings';
import '../settings/kiosk/kiosk_settings';
import '../settings/squidkiosk/squid_kiosk_settings';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "shared": {
                        "nested": {
                          "DeviceProfile": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "shared": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              },
                              "version": {
                                "type": "int32",
                                "id": 3,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "createdAt": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "updatedAt": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "type": {
                                "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                                "id": 7,
                                "rule": "optional"
                              },
                              "sposSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.spos.SPOSSettings",
                                "id": 8,
                                "rule": "optional"
                              },
                              "rtlSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.rtl.RTLSettings",
                                "id": 9,
                                "rule": "optional"
                              },
                              "kdsSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.kds.KDSSettings",
                                "id": 10,
                                "rule": "optional"
                              },
                              "rstSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.RSTSettings",
                                "id": 11,
                                "rule": "optional"
                              },
                              "terminalApiSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.terminal.TerminalAPISettings",
                                "id": 12,
                                "rule": "optional"
                              },
                              "squareHardwareSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.device.SquareHardwareSettings",
                                "id": 13,
                                "rule": "optional"
                              },
                              "aposSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.apos.APOSSettings",
                                "id": 14,
                                "rule": "optional"
                              },
                              "rstMobileSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.RSTMobileSettings",
                                "id": 15,
                                "rule": "optional"
                              },
                              "kdsExpoSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.kds.KDSExpoSettings",
                                "id": 16,
                                "rule": "optional"
                              },
                              "releaseManagerSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.ReleaseManagerSettings",
                                "id": 17,
                                "rule": "optional"
                              },
                              "fnbKioskSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.FNBKioskSettings",
                                "id": 18,
                                "rule": "optional"
                              },
                              "iposSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.ipos.IPOSSettings",
                                "id": 19,
                                "rule": "optional"
                              },
                              "kioskSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.kiosk.KIOSKSettings",
                                "id": 20,
                                "rule": "optional"
                              },
                              "squidKioskSettings": {
                                "type": ".squareup.devicesettings.profiles.v2.model.settings.squidkiosk.SquidKioskSettings",
                                "id": 21,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.shared?.nested?.DeviceProfile) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceProfile @ squareup/devicesettings/profiles/v2/model/shared/device_profile.proto at 26:1
 */
export const DeviceProfile = $root.lookupType('squareup.devicesettings.profiles.v2.model.shared.DeviceProfile');
fixType(DeviceProfile, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceProfile);